import { render } from "./ProductGooval.vue?vue&type=template&id=7fdd621d&scoped=true"
import script from "./ProductGooval.vue?vue&type=script&lang=js"
export * from "./ProductGooval.vue?vue&type=script&lang=js"

import "./ProductGooval.vue?vue&type=style&index=0&id=7fdd621d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdd621d"]])

export default __exports__